/**
 * Google Analytics 4 (GA4) para a SPA. O snippet oficial do gtag vive CRU no
 * index.html (o verificador do GA4 lê o HTML estático - script injetado em
 * runtime aparece como "coleta não ativa"). Aqui a gente só acompanha as
 * trocas de rota (roteamento próprio por history.pushState/replaceState +
 * popstate, sem react-router) e dispara os page_view seguintes - o primeiro
 * sai do próprio `config` do snippet.
 */
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let started = false;

function currentPath(): string {
  return window.location.pathname + window.location.search;
}

/** Dispara um page_view manual (trocas de rota da SPA). */
export function trackPageview(path = currentPath()): void {
  if (!window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/**
 * Liga o rastreio de rota da SPA: envolve push/replaceState e ouve o popstate.
 * Sem o gtag no HTML (ex.: dev local sem rede), vira no-op.
 */
export function initAnalytics(): void {
  if (started || typeof window === "undefined") return;
  started = true;

  const fire = () => trackPageview();
  const wrap = (method: "pushState" | "replaceState") => {
    const original = history[method];
    history[method] = function (this: History, ...args: Parameters<History["pushState"]>) {
      const ret = original.apply(this, args);
      // deixa a URL assentar antes de ler o path
      queueMicrotask(fire);
      return ret;
    };
  };
  wrap("pushState");
  wrap("replaceState");
  window.addEventListener("popstate", fire);
}
